<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Curriculum" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="Curriculum.name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select :loading="loading" item-value="id" item-text="name" single-line v-model="Curriculum.ClassId"
              outlined :hide-details="classErrors.length === 0" dense :error-messages="classErrors" :items="classes"
              label="Select Department"></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import curriculumService from "../service.js";
import classService from "@/modules/Classes/service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editCurriculum: {
      type: Object,
    },
  },
  name: "update-curriculum",
  data() {
    return {
      loading: false,
      dialog: false,
      classes: [],
      Curriculum: {
        name: null,
        ClassId: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Curriculum: {
      name: {
        required,
      },
      ClassId: {
        required,
      },
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.Curriculum.name.$dirty) return errors;
      if (!this.$v.Curriculum.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    classErrors() {
      const errors = [];
      if (!this.$v.Curriculum.ClassId.$dirty) return errors;
      if (!this.$v.Curriculum.ClassId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.Curriculum = JSON.parse(JSON.stringify(this.editCurriculum));
      this.dialog = val;
      if (val)
        this.getClasses()
    },
  },
  methods: {
    getClasses() {
      this.loading = true;
      classService.getAll().then(response => {
        this.loading = false;
        this.classes = response.data
      }).catch(error => {
        this.loading = false;
        console.log('error getting classes', error)
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Curriculum = {
        name: null,
        ClassId: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return curriculumService
          .update(this.Curriculum.id, this.Curriculum)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Curriculum is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
